var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"normal-btn-text elevation-0 rounded-tag-small",attrs:{"loading":_vm.loading,"small":""},on:{"click":_vm.onClickDownloadDanfe}},[_vm._v(" DANFE ")])}
var staticRenderFns = []

export { render, staticRenderFns }